import { render } from "./ChartBlock.vue?vue&type=template&id=c27f378a&scoped=true"
import script from "./ChartBlock.vue?vue&type=script&lang=js"
export * from "./ChartBlock.vue?vue&type=script&lang=js"

import "./ChartBlock.vue?vue&type=style&index=0&id=c27f378a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27f378a"]])

export default __exports__